import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** 文字コード */
enum CharacterCode {
  ms932 = 'MS932',
  utf16 = 'UTF-16',
  utf8 = 'UTF-8',
}

const nameConfig = {
  ms932: new Map([
    [Locale.ja, 'MS932 日本語(Windows-31J)'],
    [Locale.en, 'MS932 Japanese(Windows-31J)'],
  ]),
  utf16: new Map([
    [Locale.ja, 'UTF-16 UTF-16'],
    [Locale.en, 'UTF-16 UTF-16'],
  ]),
  utf8: new Map([
    [Locale.ja, 'UTF-8 UTF-8'],
    [Locale.en, 'UTF-8 UTF-8'],
  ]),
};

const toDisplay = enumToName(CharacterCode, nameConfig);
const toDisplayWithPrefix = enumToName(CharacterCode, nameConfig, { prefix: true });

export const characterCode = {
  enum: CharacterCode,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { CharacterCode };
